import React, { Fragment } from 'react';

import { appSettings } from 'wanderu-config';

const HeadSnippet = () => {
    const {
        id,
        serverContainerUrl,
    } = appSettings.config.google.gtm;

    return (
        <Fragment>
            <script dangerouslySetInnerHTML={{
                __html: `
                /* Google Tag Manager */
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                '${serverContainerUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${id}');
                /* End Google Tag Manager */
            `,
            }}
            />
        </Fragment>
    );
};

export default HeadSnippet;
